import { render } from "./mm-edit.vue?vue&type=template&id=009c6a2f"
import script from "./mm-edit.vue?vue&type=script&lang=js"
export * from "./mm-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__